import { Button } from '@ui/components';
import { Trash2Icon } from 'lucide-react';
import { FC } from 'react';

interface DeleteButtonProps {
  onClick?: () => void;
}

export const DeleteButton: FC<DeleteButtonProps> = (props) => {
  const { onClick } = props;
  return (
    <Button
      className="ml-auto hidden h-10 lg:flex"
      size="sm"
      variant="outline"
      onClick={onClick}
    >
      <Trash2Icon className="mr-2 size-4" />
      Delete
    </Button>
  );
};
